import styles from './app.module.scss';
import {
  globalActions,
  getApplicationLanguageTranslations,
  getApplicationDirection,
  selectcurrentStatus,
  getApplicationLocale,
  getCopilotConfig
} from '@nice-ccf/ui-components';
import {
  CcfTranslatorProvider,
  CcfTranslatorProviderType,
} from '@nice-ccf/ui-controls';
import { createTheme } from '@mui/material/styles';
import { jssPreset } from '@mui/styles';
import { CXoneBreezeThemeOptions } from '../cxone-agent-demo.theme.config';
import StylesProvider from '@mui/styles/StylesProvider';
import {
  Box,
  CssBaseline,
  Direction,
  responsiveFontSizes,
  StyledEngineProvider,
  ThemeOptions,
  ThemeProvider,
} from '@mui/material';
import { useEffect } from 'react';
import { routes } from './app.routes';
import { useDispatch, useSelector } from 'react-redux';
import { closechannel, simulatorBroadcastListener } from './simulatorListener';
import { create } from 'jss';
import appToastStyles from '../styles.toast';
import ccfAppStyles from './app.style';
import rtl from 'jss-rtl';
import { CcfRouteMapper } from '@nice-ccf/ui-components';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

/**
 * DatePickerIcon used to display date picker icon
 * @example <DatePickerIcon />
 */
export function App() {
  const coPilotConfigurations = useSelector(getCopilotConfig);
  const dispatch = useDispatch();
  const locale = useSelector(getApplicationLocale);
  const supportedLanguages = ['en-US', 'he', 'pt-BR'];
  const { setLanguageConfiguration } = globalActions;
  const agentCurrentStatus = useSelector(selectcurrentStatus);
  const translationsConfig: CcfTranslatorProviderType = useSelector(
    getApplicationLanguageTranslations
  );
  const appDirection: Direction = useSelector(getApplicationDirection);
  const jss =
    appDirection === 'rtl'
      ? create({ plugins: [...jssPreset().plugins, rtl()] })
      : create({ plugins: [...jssPreset().plugins] });

  const cxoneAgentThemeOptions: ThemeOptions = {
    ...CXoneBreezeThemeOptions,
    direction: appDirection,
  };
  let cxoneAgentTheme = createTheme(cxoneAgentThemeOptions);
  cxoneAgentTheme = responsiveFontSizes(cxoneAgentTheme);
  const classes = appToastStyles(cxoneAgentTheme);
  const appStyles = ccfAppStyles(cxoneAgentTheme);

  useEffect(() => {
    // Set Application Language Based on Browser Preference
    const userPreferredLanguages = window.navigator.languages;
    const supportedPreferredLanguage =
      userPreferredLanguages.find(
        (language) => supportedLanguages.indexOf(language) !== -1
      ) || 'en-US'; 
      dispatch(setLanguageConfiguration(supportedPreferredLanguage || 'en-US'));
    }, []);

  useEffect(() => {
    //broadcast listner
    if (agentCurrentStatus !== 'Working-OB') {
      simulatorBroadcastListener(dispatch, agentCurrentStatus);
    } else {
      closechannel();
    }
  }, [agentCurrentStatus]);



  return (
    <Box
      sx={{ ...classes.toast, ...appStyles.scroll }}
      className={`${styles.app} heightInherit`}
    >
      <main className="heightInherit">
        <CcfTranslatorProvider translations={translationsConfig}>
          <CssBaseline />
          <StylesProvider jss={jss}>
            <StyledEngineProvider injectFirst>
              <ThemeProvider theme={cxoneAgentTheme}>
                <ToastContainer
                  enableMultiContainer
                  containerId={'AppToastContainer'}
                  position="top-center"
                  newestOnTop={false}
                  closeOnClick={false}
                  rtl={false}
                  pauseOnFocusLoss
                  draggable={false}
                  closeButton={true}
                  hideProgressBar
                />
               <CcfRouteMapper routes={routes} /> 
              </ThemeProvider>
            </StyledEngineProvider>
          </StylesProvider>
        </CcfTranslatorProvider>
      </main>
    </Box>
  );
}

export default App;
